export default function ContextAdsHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/19d0b3354098c82e2ad4c1fd0efa4ee8.jpg"
          alt="Профессиональная настройка контекстной рекламы Google и Яндекс"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D1B35]/80 via-[#0D1B35]/70 to-[#0D1B35]/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 py-24 sm:py-28 text-center">
        <div className="inline-flex flex-wrap items-center justify-center gap-2 bg-[#C5A880]/40 border border-[#C5A880]/80 text-[#FFE0A8] px-3 sm:px-4 py-2 rounded-2xl sm:rounded-full text-xs font-semibold mb-5 font-['Montserrat'] backdrop-blur-sm max-w-xs sm:max-w-none text-center">
          <i className="ri-bar-chart-2-line"></i>
          <span>Контекстная реклама</span>
        </div>

        <h1
          className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-['Playfair_Display'] font-bold text-white mb-5 leading-tight px-1"
          style={{ textShadow: '0 2px 20px rgba(0,0,0,0.9), 0 1px 6px rgba(0,0,0,0.8)' }}
        >
          Профессиональная настройка
          <span className="block mt-1">контекстной рекламы</span>
        </h1>

        <p
          className="text-sm sm:text-xl text-[#FFE0A8] font-bold mb-3 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] px-1"
          style={{ textShadow: '0 2px 12px rgba(0,0,0,0.85)' }}
        >
          Горячие клиенты из поиска Google и Яндекса
        </p>

        <p
          className="text-sm sm:text-lg md:text-xl text-white font-semibold mb-10 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] px-1"
          style={{ textShadow: '0 2px 16px rgba(0,0,0,0.95), 0 1px 4px rgba(0,0,0,0.8)' }}
        >
          Системный запуск рекламы с глубоким маркетинговым погружением.
          Каждый вложенный рубль работает на результат.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <a
            href="#context-ads-form"
            className="group w-full sm:w-auto bg-[#C5A880] hover:bg-[#B39770] text-white px-7 py-4 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Запустить рекламу
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </a>
          <a
            href="#context-ads-what"
            className="group w-full sm:w-auto bg-white/20 backdrop-blur-md hover:bg-white/30 text-white border-2 border-white/40 px-7 py-4 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Узнать подробнее
          </a>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 gap-4 sm:gap-8 max-w-sm mx-auto">
          {[
            { value: '7+', label: 'лет опыта' },
            { value: '30+', label: 'разных ниш и бизнесов' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl sm:text-4xl font-bold text-[#C5A880] font-['Playfair_Display']" style={{ textShadow: '0 2px 12px rgba(0,0,0,0.8)' }}>
                {stat.value}
              </div>
              <div className="text-white/70 text-xs sm:text-sm font-['Montserrat'] mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
